export const passwordRequestFail = [
  {
    title: "password.notMatchingTitle",
    messages: [
      {
        text: "password.notMatching",
        type: "error",
      },
    ],
  },
];
export const passwordUpdateFailedGeneric = [
  {
    title: "password.updateFailedGenericTitle",
    messages: [
      {
        text: "password.updateFailedGeneric",
        type: "error",
      },
    ],
  },
];
export const errorMsg = [
  {
    title: "somethingIsNotRight",
    messages: [
      {
        text: "password.error",
        type: "error",
      },
      {
        text: "password.capitalSmall",
        type: "error",
      },
      {
        text: "password.digit",
        type: "error",
      },
      {
        text: "password.specialCharacter",
        type: "error",
      },
      {
        text: "password.matching",
        type: "error",
      },
      {
        text: "password.currentPassEmpty",
        type: "error",
      },
    ],
  },
];
export const confirmPasswordMsg = [
  {
    title: "Password does not match",
    messages: [
      {
        text: "The passwords does not match the new one. Please make sure both new passwords are are identical.",
        type: "error",
      },
    ],
  },
];

export const verificationCodeFail = [
  {
    title: "Verification failed",
    messages: [
      {
        text: "Your attempt to verify failed. Please make sure you entered the correct Verification Code we sent you.",
        type: "error",
      },
    ],
  },
];

export const verificationCodeSuccess = [
  {
    title: "Password change success",
    messages: [],
  },
];

export const resendCodeSendFail = [
  {
    title: "Code resend failed",
    messages: [
      {
        text: "There was a problem resending the code. Plesae try again",
        type: "error",
      },
    ],
  },
];

export const verifyCodeinvalid = [
  {
    title: "verifyCodeInvalidTitle",
    messages: [
      {
        text: "verifyCodeInvalidDescription",
        type: "error",
      },
    ],
  },
];
